import React, { useEffect, useState } from 'react'

import { EMAIL_READ_ICON } from '../../constants/urls'

import Modal from '../shared/Modal'
import Button from '../shared/Button'

interface SentConfirmationProps {
  handleClose: () => void
  handleSubmit: () => void
  companyColor: string
  loading: boolean
}

const SentConfirmation: React.FC<SentConfirmationProps> = ({ handleClose, handleSubmit, companyColor, loading }: SentConfirmationProps) => {
  const [timer, setTimer] = useState(60)
  const buttonText = timer === 0 ? 'Reenviar Orden' : `Reenviar Orden en ${timer} segundos`

  useEffect(() => {
    if (timer === 0) return undefined
    const interval = setInterval(() => {
      setTimer(t => t - 1)
    }, 1000)
    return () => clearInterval(interval)
  }, [timer])

  useEffect(() => {
    if (!loading) {
      setTimer(60)
    }
  }, [loading])

  return (
    <Modal show>
      <div className='flex justify-center items-center mb-2'>
        <img src={EMAIL_READ_ICON} alt="email read" className='w-12 h-12' />
      </div>

      <div className='text-center mb-8 px-10'>
        <h1 className='font-semibold text-2xl mb-2'>Listo</h1>
        <p className='text-gray-500 font-medium text-base'>Si el correo está asociado a la compra, te enviaremos el número de orden. Revisa tu bandeja de entrada</p>
      </div>

      <div className='h-12 mb-4'>
        <Button onClick={handleSubmit} disabled={timer > 0} text={buttonText} companyColor={companyColor} dark />
      </div>
      <Button text="Salir" companyColor={companyColor} dark={false} onClick={handleClose} />
    </Modal>
  )
}

export default SentConfirmation
